import {
    PAYMENT_GATEWAY_REQ,
    PAYMENT_GATEWAY_SUCCESS,
    PAYMENT_GATEWAY_ERROR,
    ADD_MONEY_VALUE,
    PAYMENT_GATEWAY_RESET_VALUE,
    TRANSACTION_CONFIRMATION_REQUEST,
    TRANSACTION_CONFIRMATION_SUCCESS,
    TRANSACTION_CONFIRMATION_ERROR
} from "../actionType";

export const getPaymentGatewayReq = () => ({
    type: PAYMENT_GATEWAY_REQ,
});

export const getPaymentGatewaySuccess = (data:any) => ({
    type: PAYMENT_GATEWAY_SUCCESS,
    payload: data
});

export const getPaymentGatewayError = (error: any) => ({
    type: PAYMENT_GATEWAY_ERROR,
    payload: error
});

export const getAddMoneyValue = (value: any) => ({
    type: ADD_MONEY_VALUE,
    payload: value
});

// confirmation
export const getTransactionConfirmation = () => ({
    type:TRANSACTION_CONFIRMATION_REQUEST
});

export const getTransactionConfirmationSuccess = (data:any) => ({
    type:TRANSACTION_CONFIRMATION_SUCCESS,
    payload: data
})

export const getTransactionConfirmationError = (error:any) => ({
    type:TRANSACTION_CONFIRMATION_ERROR,
    payload:error
})

export const getResetValue = () => ({
    type: PAYMENT_GATEWAY_RESET_VALUE,
});